import type { ComponentMultiStyleConfig } from '@chakra-ui/theme'

const Stat: ComponentMultiStyleConfig = {
  parts: ['container', 'label', 'helpText', 'number', 'icon'],
  baseStyle: {
    container: {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'gray.200',
      borderRadius: '11px',
      padding: '20px',
    },
  },
}

export default Stat
